import { AxiosResponse } from 'axios';

export type FieldApiError = { field: string; message: string };

export type ApiErrorBody = {
  status?: string;
  code?: number;
  message?: string;
  type?: string;
  fields?: FieldApiError[];
  extra?: Record<string, unknown>;
};

export type CommonApiError = AxiosResponse<ApiErrorBody>;

export const API_ERROR_TYPE = {
  notAccredited: 'ExcNotAccredited',
  duplicateKey: 'ExcDuplicateKey',
  companyBlocked: 'ExcCompanyBlocked',
  userBlocked: 'ExcUserBlocked',

  // Переназначение клиентов
  validation: 'ExcClientReassignmentValidation',
  forbidden: 'ExcClientReassignmentForbidden',
  conflict: 'ExcClientReassignmentConflict',
  crm: 'ExcClientReassignmentCRM',

  // OTP
  otpResendTooSoon: 'ExcOtpResendTooSoon',
} as const;
